import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { HeaderMiddleComponent } from '../../app/content/layout/components/general/header/components/header-middle/header-middle.component';
import { UserService } from '../../app/core/services/user.service';
import { environment } from '../../environments/environment';
import { withCommonDecorators } from '../_utils/story-helpers';
import { MockLoggedInUserService } from '../_mocks/services.mock';

function setEnvironmentCountry(country: 'DK' | 'SE') {
  (environment.checkout as any).defaultCountry = country;
  (environment.supervin as any).hideGroupVoucher = country === 'SE';
  (environment.supervin as any).showB2B = country === 'DK';
}

const meta: Meta<HeaderMiddleComponent> = {
  title: 'Organisms/Header Middle',
  component: HeaderMiddleComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    layout: 'fullscreen',
  },
};

export default meta;
type Story = StoryObj<HeaderMiddleComponent>;

export const DanishVersion: Story = {
  name: 'Danish Version (DK)',
  render: () => {
    setEnvironmentCountry('DK');
    return {
      template: `
        <div style="background-color: #5c0a31; min-height: 100px;">
          <app-header-middle />
        </div>
      `,
    };
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-header-middle')).toBeTruthy();
  },
};

export const SwedishVersion: Story = {
  name: 'Swedish Version (SE)',
  render: () => {
    setEnvironmentCountry('SE');
    return {
      template: `
        <div style="background-color: #5c0a31; min-height: 100px;">
          <app-header-middle />
        </div>
      `,
    };
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-header-middle')).toBeTruthy();
  },
};

export const WithLoggedInUser: Story = {
  name: 'With Logged In User (DK)',
  decorators: [
    ...withCommonDecorators([
      { provide: UserService, useClass: MockLoggedInUserService },
    ]),
  ],
  render: () => {
    setEnvironmentCountry('DK');
    return {
      template: `
        <div style="background-color: #5c0a31; min-height: 100px;">
          <app-header-middle />
        </div>
      `,
    };
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-header-middle')).toBeTruthy();
  },
};

